/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  general: {
    save: 'সংরক্ষণ',
    autosaved: 'স্বতঃ সংরক্ষিত',
    back_to: 'আবার',
    by: 'দ্বারা',
    chat: 'চ্যাট',
    completed: 'সমাপ্ত',
    canceled: 'বাতিল করা হয়েছে',
    component: 'উপাদান',
    confirm: 'নিশ্চিত করুন',
    course: 'পাঠ ',
    date: ' তারিখ ',
    details: 'বিশদ ',
    empty: 'তথ্য নেই',
    enrolled: 'তালিকাভুক্ত',
    free: ' বিনামূল্যে ',
    graph: ' লেখচিত্র ',
    loading: ' লোড হচ্ছে...',
    lesson: ' পাঠ ',
    lessons: ' পাঠগুলি',
    live_assessment: 'সরাসরি মূল্যায়ন',
    live_event: 'লাইভ অনুষ্ঠান',
    no: 'না',
    of: 'এর',
    or: 'বা',
    organization: ' প্রতিষ্ঠান',
    page: ' পৃষ্ঠা ',
    pages: ' পৃষ্ঠাগুলি',
    personal: ' ব্যক্তিগত ',
    poll: ' ভোটগ্রহণ ',
    rating: ' নির্ধারণ ',
    reset: ' পুনরায় বসান ',
    signin: 'সাইন ইন করুন',
    signup: 'নিবন্ধন করুন',
    soon: 'শীঘ্রই',
    type: 'টাইপ করা',
    uploading: ' আপলোড হচ্ছে...',
    yes: ' হ্যাঁ ',
    something_went_wrong: 'কিছু ভুল হয়েছে!',
    view_all: 'সব দেখ',
    upload_successful: 'আপলোড সফল হয়েছে',
    upload_successful_message:
      'আপনার এক্সেল নথি সফলভাবে আপলোড হয়েছে এবং বর্তমানে প্রক্রিয়াজাত হচ্ছে। এটি কিছু সময় নিতে পারে।',
    check_email_upload_successful:
      'দয়া করে <0> আপনার ইমেলটি পরীক্ষা করুন আপলোড করা ব্যবহারকারী তালিকার <1> প্রতিবেদন </ 1> </0> এর জন্য ',
    is_private: ' ব্যক্তিগত'
  },

  account: {
    title: ' হিসাব',
    subtitle: 'আপনার সেটিংস এবং অ্যাকাউন্টের তথ্য পরিচালনা করুন।',
    saved: 'অ্যাকাউন্ট সফলভাবে পরিবর্তিত হয়েছে'
  },

  assessments: {
    title: ' মূল্যায়ন ',
    subtitle: 'একটি মূল্যায়ন তৈরি করুন',
    finished: 'মূল্যায়ন শেষ',
    countdown: 'সরাসরি মূল্যায়ন সম্প্রচারিত হবে ',
    create: 'মূল্যায়ন তৈরি করুন',
    list_title: 'আপনার মূল্যায়ন',
    delete_warning: 'আপনি এই আইটেমটি মুছে ফেলতে চান আপনি কি নিশ্চিত?',
    details_title: 'মূল্যায়নের বিশদ যুক্ত করুন',
    details_subtitle:
      'আপনার মূল্যায়নের নাম দিন এবং আপনার দর্শকদের বলুন তাদের এটি থেকে কী শিখার আশা করা উচিত ',
    disclaimer: `আমি আশ্বাস দিয়েছি যে আমার রেকর্ড করা মূল্যায়ন টি হবে না:
    - যে কোন তৃতীয় পক্ষের অধিকার লঙ্ঘন
    - মানহানি সহ, অশ্লীল, অশোভন, দুশ্চরিত্র, অশ্লীল রচনা চিত্র, উগ্র, গালিগালাজপূর্ণ, অপমানকর, হুমকি দেওয়া বা বৈষম্যমূলক বিষয়বস্তু সহ এমন কোনও অবৈধতা রয়েছে, এমনকি তারকাচিহ্ন দ্বারা ছদ্মবেশযুক্ত
    - অন্যান্য ব্যক্তির উপর কোনও ব্যক্তিগত আক্রমণ রয়েছে
    - অন্যান্য অংশগ্রহণকারী, জনসাধারণের ব্যক্তিত্ব বা সেলিব্রিটিদের কোনও ছদ্মবেশ ধারণ করে
    - এই জাতীয় ব্যক্তির সম্মতি ব্যতীত যে কোনও ব্যক্তির কোনও রেকর্ডিং বা ব্যক্তিগত তথ্য থাকতে পারে এবং বিশ্বের কোন অংশে কোনও তথ্য সুরক্ষা নিয়ন্ত্রণের লঙ্ঘন করছে না
    - যে কোনও বাণিজ্যিক আবেদন বা কোন রকম "স্প্যাম" ধারণ করে”`,
    assessment_details: 'মূল্যায়নের বিশদ',
    assessment_settings: 'মূল্যায়ন সেটিংস'
  },

  buildersettings: {
    title: 'সেটিংস প্রকাশিত',
    subtitle:
      'আপনার ইভেন্টে সেটিংস যুক্ত করুন, যারা আপনার ইভেন্টটি দেখতে ও তার সাথে ইন্টারঅ্যাক্ট করতে পারে'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: ' যুক্ত করা ',
    add_page: 'পৃষ্ঠা যোগ করো',
    add_lesson: 'পাঠ যোগ করুন',
    add_answer: 'নতুন উত্তর যুক্ত করুন',
    add_group: 'দল যুক্ত করুন',
    add_organization: 'সংস্থা যুক্ত করুন',
    add_question: 'প্রশ্ন যুক্ত করুন',
    add_quiz: 'কুইজ যুক্ত করুন',
    add_users: 'ব্যবহারকারী যুক্ত করুন',
    back: 'পেছনে',
    back_to_course: 'কোর্সের ওভারভিউ-এ ফিরে যান',
    back_to_lesson: 'পাঠ্য ওভারভিউ-এ ফিরে যান',
    back_to_media: 'মিডিয়া পাঠাগারে ফিরে যান',
    back_to_details: 'বিশদে ফিরে যান',
    cancel: ' বাতিল ',
    clear: ' স্পষ্ট ',
    close: 'বন্ধ',
    clone: 'ক্লোন',
    close_lesson: 'পাঠ বন্ধ করুন',
    clone_course: 'ক্লোন কোর্স',
    confirm: ' নিশ্চিত করুন ',
    create: 'সৃষ্টি',
    download: 'ডাউনলোড',
    download_mass_user_tamplate: 'টেম্পলেট ডাউনলোড করুন',
    add_mass_users: 'গণ ব্যবহারকারীদের যোগ করুন',
    upload_excel_list: 'এক্সেল তালিকা আপলোড করুন',
    delete: 'মিডিয়া মুছুন',
    edit: ' সম্পাদনা করুন ',
    edit_course: 'সম্পাদনা কোর্স',
    enroll: ' তালিকাভুক্তি ',
    finish: ' সমাপ্ত ',
    upload_image: 'ছবি আপলাড',
    upload_image_video: 'ছবি বা ভিডিও আপলোড করুন',
    select_media_library: 'মিডিয়া লাইব্রেরি নির্বাচন করুন',
    make_public: 'জনসাধারণের জন্য উন্মুক্ত করো',
    make_private: 'ব্যক্তিগত করো',
    make_org: 'সংস্থা তৈরি করুন',
    media: 'মিডিয়া গ্রন্থাগার',
    my_theme: 'আমার থিম',
    next: ' পরবর্তী ',
    next_lesson: 'পরবর্তী পাঠ',
    next_step: 'পরবর্তী ধাপ ',
    previous_step: 'পূর্ববর্তী ধাপ',
    publish: 'প্রকাশ',
    publish_assessment: 'আপনার মূল্যায়ন প্রকাশ করুন',
    publish_course: 'আপনার কোর্স প্রকাশ করুন',
    publish_event: 'আপনার অনুষ্ঠান প্রকাশ করুন',
    reset: 'পুনরায় বসান',
    reset_elements: 'উপাদানগুলি পুনরায় সেট করুন',
    save: 'সংরক্ষণ',
    creating: ' তৈরি হচ্ছে...',
    updating: ' আপডেট হচ্ছে...',
    saved: ' সংরক্ষিত ',
    save_for_later: 'পরে জন্য সংরক্ষণ করুন',
    save_settings: 'সেটিংস সংরক্ষণ করুন',
    select_files: 'ফাইলগুলি নির্বাচন করুন',
    select_theme: 'থিম নির্বাচন করুন',
    start_lesson: 'পাঠ শুরু করুন',
    update: ' আপডেট',
    upload: ' আপলোড করুন ',
    upload_audio: 'অডিও আপলোড করুন ',
    upload_photo: 'একটি প্রোফাইল ছবি আপলোড করুন',
    upload_video: 'ভিডিও আপলোড করুন',
    enrolled: 'তালিকাভুক্ত',
    unenroll: 'তালিকাভুক্তি-নয়',
    from_library: 'সংবাদমাধ্যম গ্রন্থাগার',
    remove: 'অপসারণ',
    removed: 'স্থানান্তরিত',
    start_broadcast: 'সম্প্রচার শুরু করুন',
    end_broadcast: `সম্প্রচার সমাপ্ত`,
    camera: 'ক্যামেরা',
    screen: 'পর্দা',
    screen_with_camera: 'ক্যামেরা সহ পর্দা',
    insert: 'ভিতরে স্থাপন করা',
    inserting: 'সন্নিবেশিত করা'
  },

  card: {
    quick_add: 'দ্রুত যুক্ত করা',
    add: ' যুক্ত করা',
    clone: 'ক্লোন',
    completed: 'পাঠ সম্পন্ন'
  },

  course: {
    upcoming_course: 'আসন্ন কোর্স',
    unPublishEvent: 'অপ্রকাশিত ইভেন্ট',
    unPublishAssessment: 'অপ্রকাশিত মূল্যায়ন',
    pastCourse: 'প্রশিক্ষণ কোর্স',
    upcoming: 'আসন্ন সরাসরি ইভেন্ট',
    pastEvent: 'অতীতের সরাসরি ইভেন্ট',
    pastAssessment: 'অতীতের সরাসরি মূল্যায়ন',
    upcomingAssessment: 'আসন্ন সরাসরি মূল্যায়ন',
    created: 'তারিখ নির্ধারণ করা হয়েছে:',
    assignees: 'অধিকারপ্রাপ্ত প্রতিনিধি',
    organisations:
      ' {{ সংগঠনগুলি }} সংগঠনগুলি, <2> {{ users }} ব্যবহারকারী</2>',
    event_date: 'সরাসরি ইভেন্টের তারিখ <1> {{ তারিখ }} </1>',
    delete_warning: 'আপনি কি নিশ্চিত যে আপনি এটি মুছতে চান',
    clonning_no_lesson:
      'এই কোর্সটি ক্লোন করতে দয়া করে কমপক্ষে একটি পাঠ যোগ করুন.',
    clone_warning: 'আপনি কি নিশ্চিত যে আপনি এটি ক্লোন করতে চান',
    clone_success: 'ক্লোনিং প্রক্রিয়া চলছে',
    disclaimer: ` আমি নিশ্চিত করি যে আমার কোর্সটি না:
      - যে কোন তৃতীয় পক্ষের অধিকার লঙ্ঘন
      - মানহানি সহ, অশ্লীল, অশোভন, দুশ্চরিত্র, অশ্লীল রচনা চিত্র, উগ্র, গালিগালাজপূর্ণ, অপমানকর, হুমকি দেওয়া বা বৈষম্যমূলক বিষয়বস্তু সহ এমন কোনও অবৈধতা রয়েছে, এমনকি তারকাচিহ্ন দ্বারা ছদ্মবেশযুক্ত
      - অন্যান্য ব্যক্তির উপর কোনও ব্যক্তিগত আক্রমণ রয়েছে
      - অন্যান্য অংশগ্রহণকারী, জনসাধারণের ব্যক্তিত্ব বা সেলিব্রিটিদের কোনও ছদ্মবেশ ধারণ করে
      - এই জাতীয় ব্যক্তির সম্মতি ব্যতীত যে কোনও ব্যক্তির কোনও রেকর্ডিং বা ব্যক্তিগত তথ্য থাকতে পারে এবং বিশ্বের কোন অংশে কোনও তথ্য সুরক্ষা নিয়ন্ত্রণের লঙ্ঘন করছে না
      - যে কোনও বাণিজ্যিক আবেদন বা কোন রকম "স্প্যাম" ধারণ করে”`
  },

  coursecreate: {
    dropzone_text: 'মিডিয়া প্রবেশ করান',
    sidebar_text: 'একটি থিম নির্বাচন করুন  <1/> আপনার <3/> পাঠের জন্য ',
    delete_warning: 'আপনি কি নিশ্চিত যে আপনি এই পাঠটি মুছতে চান?'
  },

  coursepage: {
    quizview_loading:
      'উত্তরগুলি পরীক্ষা করা হচ্ছে। অনুগ্রহপূর্বক অপেক্ষা করুন...',
    quizview_answer: 'তোমার উত্তর'
  },

  coursequiz: {
    title: 'সমস্ত পাঠের কুইজ '
  },

  dashboard: {
    tooltip_title: 'এই ভিডিওটি আবার দেখাবেন না',
    page_title: `'আপনার কোর্সসমূহ' পরিসংখ্যানসংক্রান্ত `,
    page_subtitle: 'আপনি তৈরি কোর্সের অবস্থা',
    profile_add_info: `আপনার প্রোফাইল সম্পূর্ণ করতে আপনার <1> {{অসম্পূর্ণ টেক্সট}} </1> যুক্ত করুন'`,
    profile_build: `আপনার প্রোফাইল তৈরি করুন <1> এখানে </ 1>, আপনার আগ্রহ এবং দক্ষতা আমাদের জানান'`,
    profile_title: 'প্রোফাইল ক্ষমতা',
    more_details: 'আরো বিস্তারিত'
  },

  errors: {
    answer: 'দয়া করে উত্তর ইনপুট করুন',
    answer_correct: 'সঠিক উত্তরটি নির্বাচন করুন',
    code: 'দয়া করে আপনার কোড ইনপুট করুন',
    criterion: 'দয়া করে মানদন্ডটি ইনপুট করুন',
    duration: 'স্থিতিকাল প্রয়োজন',
    element: 'দয়া করে উপাদান ইনপুট করুন',
    email: 'দয়া করে আপনার ইমেলটি ইনপুট করুন',
    email_invalid: 'ইনপুট করা ইমেল বৈধ নয়',
    feedback_correct: 'দয়া করে প্রতিক্রিয়া সঠিকভাবে ইনপুট করুন',
    feedback_incorrect: 'দয়া করে প্রতিক্রিয়া ভুল ইনপুট করুন',
    host: 'দয়া করে ইভেন্ট পরিচালনাকারী ইনপুট করুন',
    host_assessment: 'দয়া করে মূল্যায়ন পরিচালনাকারী ইনপুট করুন',
    image: 'দয়া করে একটি ছবি আপলোড করুন',
    location: 'দয়া করে আপনার অবস্থানটি ইনপুট করুন',
    live_location: 'দয়া করে সম্প্রচারের একটি জায়গা বেছে নিন',
    limit: 'দয়া করে সরাসরি স্ট্রিমিং মিনিট ইনপুট করুন',
    min_3char: '৩ সর্বনিম্ন অক্ষর',
    number: 'দয়া করে ধনাত্মক সংখ্যা ইনপুট করুন',
    host_email_require: ` পরিচালনাকারীর ইমেলগুলি অবশ্যক `,
    attendee_email_require: ` অংশগ্রহণকারীদের ইমেলগুলি অবশ্যক`,
    name: 'দয়া করে আপনার নাম ইনপুট করুন',
    not_found_course: 'কোর্স পাওয়া যায়নি',
    not_found_event: 'ইভেন্ট পাওয়া যায় নি',
    not_found_assessment: 'মূল্যায়ন পাওয়া যায়নি',
    password: 'দয়া করে আপনার পাসওয়ার্ড ইনপুট করুন',
    password_digit: 'কমপক্ষে একটি সংখ্যা',
    password_short: 'পাসওয়ার্ড খুব ছোট, নূন্যতম ১০ টি অক্ষর',
    password_special: 'কমপক্ষে একটি বিশেষ চিহ্ন',
    password_uppercase: 'কমপক্ষে একটি বড় হাতের অক্ষর',
    password_lowercase: 'কমপক্ষে একটি ছোট হাতের অক্ষর',
    phone: 'দয়া করে আপনার ফোনটি ইনপুট করুন',
    phone_invalid: 'অকার্যকর ফোন নম্বর',
    position: 'দয়া করে আপনার অবস্থান ইনপুট করুন',
    question: 'দয়া করে প্রশ্ন ইনপুট করুন',
    start_date: 'শুরু করার তারিখ & সময় অবশ্যক',
    tag: 'দয়া করে একটি ট্যাগ নির্বাচন করুন',
    topics: 'দয়া করে কমপক্ষে একটি বিষয় নির্বাচন করুন।',
    live_topics: 'দয়া করে বিষয় যুক্ত করুন',
    title: 'দয়া করে শিরোনাম ইনপুট করুন',
    title_assessment: 'দয়া করে মূল্যায়ন শিরোনাম ইনপুট করুন',
    title_course: 'দয়া করে পাঠ্যক্রমের শিরোনাম ইনপুট করুন',
    title_empty: 'শিরোনাম খালি থাকতে পারে না',
    title_event: 'দয়া করে ইভেন্টের শিরোনাম ইনপুট করুন',
    title_lesson: 'দয়া করে পাঠ্য শিরোনাম ইনপুট করুন',
    title_quiz: 'দয়া করে কুইজের নাম ইনপুট করুন',
    username: 'দয়া করে আপনার ব্যবহারকারীর নাম ইনপুট করুন',
    upload_error: 'ভুল- ফাইল সামঞ্জস্যপূর্ণ নয়!',
    upload_more_than_10: `আপনি একবারে সর্বোচ্চ ১০ টি ফাইল আপলোড করতে পারবেন' `,
    topics_max: 'দয়া করে সর্বোচ্চ ৩ টি বিষয় যুক্ত করুন',
    upload_excel: 'দয়া করে নিশ্চিত হয়ে নিন যে আপনি সঠিক ফাইলটি আপলোড করেছেন',
    title_excel: 'টেমপ্লেট আপলোড করার সময় ত্রুটি:',
    file_size_exceed: 'ফাইলের আকার অতিক্রম',
    subtitle_excel:
      'দয়া করে নিশ্চিত করুন যে আপনি সরবরাহিত টেম্পলেটটি ব্যবহার করেছেন এবং কলামগুলি সঠিকভাবে পূরণ হয়েছে',
    select_broadcast_option:
      'দয়া করে এই ইভেন্টটি সম্প্রচারের জন্য একটি বিকল্প নির্বাচন করুন',
    multi_hosts_number_error:
      'না। উপস্থাপক এর ইভেন্টের জন্য নির্দিষ্ট চেয়ে অতিক্রম করতে পারে না। ',
    conference_people_number_error: `না। অংশগ্রহণকারীদের ইভেন্টের জন্য নির্দিষ্ট করা ছাড়িয়ে বেশি হতে পারে না’,
   select_max_host: 'ইভেন্টটির জন্য কমপক্ষে 1 টি উপস্থাপক নির্বাচন করুন' ',
   select_max_conference: 'ইভেন্টের জন্য কমপক্ষে 1 জন অংশগ্রহণকারী নির্বাচন করুন',
   stream_stop_error: 'অপ্রত্যাশিতভাবে স্ট্রিমিং বন্ধ হয়ে গেছে!',
   unsecure_context:
     'মারাত্মক ত্রুটি: অনিরাপদ প্রসঙ্গের কারণে ব্রাউজার ক্যামেরা এবং মাইকে অ্যাক্সেস করতে পারে না।দয়া করে এসএসএল ইনস্টল করুন এবং https এর মাধ্যমে অ্যাক্সেস করুন',
   ws_not_supported: 'মারাত্মক ত্রুটি: ওয়েব সকেট এই ব্রাউজারে সমর্থিত নয়'`,
    no_org: 'এগিয়ে যাওয়ার জন্য কমপক্ষে 1 টি সংস্থা নির্বাচন করুন',
    no_org_group: 'এগিয়ে যাওয়ার জন্য কমপক্ষে 1 টি সংগঠন গ্রুপ নির্বাচন করুন',
    waiting_to_join: 'কারও সাথে যোগ দেওয়ার অপেক্ষা!'
  },

  events: {
    title: 'লাইভ ইভেন্টের বিবরণ যুক্ত করুন',
    change_host: 'পরিচালনাকারী পরিবর্তন করুন',
    finished: 'ইভেন্টটি শেষ হয়েছে',
    countdown: 'সরাসরি ইভেন্টটি সম্প্রচারিত হবে ',
    subtitle:
      'আপনার সরাসরি ইভেন্টটির নাম দিন এবং আপনার দর্শকদের এটি থেকে কী শিখার আশা করা উচিত তা বলুন ',
    poll_disabled: 'এই ইভেন্টে ভোটগ্রহণ পাওয়া যায় না',
    disclaimer: ` আমি আশ্বাস দিয়েছি যে আমার রেকর্ড করা অনুষ্ঠানটি হবে না:
    - যে কোন তৃতীয় পক্ষের অধিকার লঙ্ঘন
  - মানহানি সহ, অশ্লীল, অশোভন, দুশ্চরিত্র, অশ্লীল রচনা চিত্র, উগ্র,গা লিগালাজপূর্ণ, অপমানকর, হুমকি দেওয়া বা বৈষম্যমূলক বিষয়বস্তু সহ এমন কোনও অবৈধতা রয়েছে, এমনকি তারকাচিহ্ন দ্বারা ছদ্মবেশযুক্ত
  - অন্যান্য ব্যক্তির উপর কোনও ব্যক্তিগত আক্রমণ রয়েছে
  - অন্যান্য অংশগ্রহণকারী, জনসাধারণের ব্যক্তিত্ব বা সেলিব্রিটিদের কোনও ছদ্মবেশ ধারণ করে
  - এই জাতীয় ব্যক্তির সম্মতি ব্যতীত যে কোনও ব্যক্তির কোনও রেকর্ডিং বা ব্যক্তিগত তথ্য থাকতে পারে এবং বিশ্বের কোন অংশে কোনও তথ্য সুরক্ষা নিয়ন্ত্রণের লঙ্ঘন করছে না
  - যে কোনও বাণিজ্যিক আবেদন বা কোন রকম "স্প্যাম" ধারণ করে”`,
    prompt_message:
      'এই পৃষ্ঠাটি ছেড়ে যাওয়া আপনার ইভেন্টটি শেষ করবে। আপনি কি এই পৃষ্ঠাটি ছেড়ে যাওয়ার বিষয়ে নিশ্চিত?',
    duration_exceed_message:
      'আপনার সম্প্রচারের সময় ছাড়িয়ে গেছে, অ্যাপটি সম্প্রচার বন্ধ করবে',
    before_schedule_message:
      'আপনি নির্ধারিত ইভেন্টের সময়ের আগে সম্প্রচার শুরু করতে চলেছেন। অনুগ্রহ করে নোট করুন যে সম্প্রচারটি থামানো ইভেন্টটি শেষ করবে ',
    browser_unsupportive_message:
      'আপনার ব্রাউজার স্ক্রিন ভাগ সমর্থন করে না। আপনি এই লিঙ্কটিতে সমর্থিত ব্রাউজারগুলি দেখতে পারেন ',
    cancel_switch_host_message:
      'উপস্থাপক উপলব্ধ নয়। আপনি ইভেন্টি যেখান থেকে শেষ করবেন সেখান থেকে অব্যাহত থাকবে.',
    coaching_prompt_message:
      'ইভেন্টটি শেষ না হওয়া পর্যন্ত আপনি এই পৃষ্ঠাটি ছেড়ে যেতে পারবেন না।',
    event_modal_warn: 'আপনি কি এই অনুষ্ঠানটি ছেড়ে যেতে চান?',
    confirm_message: 'আপনি ঠিক আছে ক্লিক করলে আপনার ইভেন্টটি শেষ হবে।',
    screen_share_denied: 'আপনি আপনার স্ক্রিন ভাগ করতে অস্বীকার করেছেন',
    media_not_found:
      'আপনার ডিভাইসে ক্যামেরা বা মাইক পাওয়া যায় না বা অনুমোদিত নয়।',
    media_not_access:
      'ক্যামেরা বা মাইকটি অন্য কোনও প্রক্রিয়া দ্বারা ব্যবহৃত হচ্ছে যা ডিভাইসগুলি পড়তে দেয় না',
    constraint_error:
      'এমন কোনও ডিভাইস পাওয়া যায় নি যা আপনার ভিডিও এবং অডিও সীমাবদ্ধগুলিকে ফিট করে। আপনি ভিডিও এবং অডিও সীমাবদ্ধতা পরিবর্তন করতে পারেন',
    media_access_denied: 'আপনার ক্যামেরা এবং মাইক অ্যাক্সেস করার অনুমতি নেই।'
  },

  filters: {
    days7: 'গত ৭ দিন',
    days15: 'গত ১৫ দিন',
    days30: 'গত ৩০ দিন',
    days365: 'গত ৩৬৫ দিন',
    date: 'তারিখ তৈরি',
    relevance: ' প্রাসঙ্গিকতা ',
    popularity: 'জনপ্রিয়তা',
    name: 'নাম',
    group: 'গ্রুপ',
    Newest_to_Oldest: 'সবচেয়ে নবীনতম থেকে প্রবীণতম',
    Oldest_to_Newest: 'সবচেয়ে প্রবীণতম থেকে নবীনতম ',
    A_Z: 'শুরু থেকে শেষ',
    Z_A: 'শেষ থেকে শুরু '
  },

  helpers: {
    password:
      'আপনার অ্যাকাউন্টের সুরক্ষা নিশ্চিত করতে আমাদের পাসওয়ার্ডে কমপক্ষে একটি ছোট হাতের সংখ্যা প্রয়োজন। আপনারও ন্যূনতম ১০ বর্ণ থাকতে হবে ',
    phone: 'দয়া করে আপনার ফোনে দেশের কোড অন্তর্ভুক্ত করুন: উদাহরণস্বরূপ: ৬৫',
    username:
      'আপনার ব্যবহারকারীর নামটিকে জনসাধারণের তথ্য হিসাবে বিবেচনা করা হয় এবং প্রয়োজনীয় হিসাবে অন্যান্য ব্যবহারকারীদের সাথে ভাগ করা হয়। এর মতো, আমরা আপনাকে সুপারিশ করি যে আপনি আপনার ব্যবহারকারীর নামটিতে ব্যক্তিগত তথ্য ব্যবহার করবেন না ',
    public_description_normal: `আপনার <0><0/> </0> সংরক্ষণ করা হয়েছে এবং এটি ডিফল্টরূপে ব্যক্তিগত হিসাবে বিবেচিত হয়. এর অর্থ হ'ল কেবল আপনি এই সামগ্রীটি দেখতে পারবেন। এই সামগ্রী প্রকাশ করার জন্য আপনি নীচের বিকল্পগুলির মধ্যে একটি নির্বাচন করতে পারেন।আপনার পাঠ্যক্রমটি সর্বজনীনে প্রকাশ করার অর্থ এটি প্ল্যাটফর্মের সমস্ত ব্যবহারকারীর জন্য উপলব্ধ। নির্দিষ্ট ব্যবহারকারীদের বিকল্প আপনাকে নির্দিষ্ট ব্যবহারকারীদের সাথে তাদের শেয়ারলুক অ্যাকাউন্টের সাথে সম্পর্কিত ইমেল ঠিকানা ব্যবহার করে আপনার কোর্স ভাগ করতে সক্ষম করবে।`,
    public_description_admin: `এই <0><0/> </0> সংরক্ষণ করা হয়েছে এবং এটি ডিফল্টরূপে ব্যক্তিগত হিসাবে বিবেচিত হয়। এর অর্থ হ'ল কেবলমাত্র আপনি (এবং সামগ্রী স্রষ্টা) এই সামগ্রীটি দেখতে পাচ্ছেন। এই সামগ্রী প্রকাশ করার জন্য আপনি নীচের বিকল্পগুলির মধ্যে একটি নির্বাচন করতে পারেন। আপনার পাঠ্যক্রমটি জনসমক্ষে প্রকাশ করার অর্থ এটি আপনার সংস্থার বাইরের অংশগুলি সহ - প্ল্যাটফর্মের সমস্ত ব্যবহারকারীদের কাছে উপলব্ধ। এটি সংস্থায় প্রকাশ করার অর্থ হ'ল সংস্থার মধ্যে থাকা সমস্ত ব্যবহারকারীরা এটি দেখতে সক্ষম হবেন।আপনি এটি ১ বা একাধিক গোষ্ঠীতে প্রকাশ করতে পারেন, যার অর্থ কেবলমাত্র সেই গোষ্ঠীর মধ্যে থাকা ব্যবহারকারীরা এটি দেখতে সক্ষম হবেন। 
  শেষ অবধি, আপনার প্রতিষ্ঠানের অভ্যন্তরে এবং বাইরের নির্দিষ্ট ব্যবহারকারীদের তাদের শেয়ারলুক অ্যাকাউন্ট ইমেল ঠিকানা ব্যবহার করে এটি প্রকাশ করার বিকল্প আপনার কাছে রয়েছে '`
  },

  labels: {
    add: 'যুক্ত',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'উত্তরের ধরন',
    answers: 'উত্তর',
    back_to_quiz: 'কুইজের তালিকায় ফিরে যান',
    back_to_question: 'প্রশ্নের তালিকায় ফিরে যান',
    chat: 'কথোপকথন',
    chat_available: 'এই ইভেন্টে কথোপকথন উপলভ্য নয়',
    chat_report: ' কথোপকথন রিপোর্ট ',
    choice_single: 'একক পছন্দ',
    choice_multiple: 'বহু নির্বাচনী',
    choice_free: '" বিনামূল্যে " পছন্দ ',
    choice_sorting: `" শ্রেণীবিভাজন " পছন্দ`,
    choice_matrix: 'ম্যাট্রিক্স বাছাই পছন্দ',
    clone_lesson_permission: 'ক্লোন অনুমতি',
    code: 'কোড',
    correct: 'সঠিক',
    created: 'তারিখ তৈরি',
    clone_modal: 'ক্লোন কোর্স',
    cloning_course: 'ক্লোনিং কোর্স...',
    cloning: 'ক্লোনিং...',
    cloning_course_desc:
      'এই প্রক্রিয়াটি কিছুটা সময় নেবে। দয়া করে ধৈর্য ধরুন',
    cloning_success: 'কোর্স "<0 />" সফলভাবে ক্লোন করা হয়েছে!',
    description: ' বর্ণনা ',
    disclaimer: 'অস্বীকৃতি',
    drop_file: 'ফাইলটি এখানে রেখে দিন...',
    duration: 'সময়কাল',
    edit: 'সম্পাদনা',
    email: 'ইমেল',
    event: 'ইভেন্ট',
    event_all: 'তার সমস্ত অনুষ্ঠান',
    event_date: 'সরাসরি ইভেন্ট স্থানীয় তারিখ / সময়',
    event_this: 'এই ঘটনা',
    expire: 'মেয়াদ শেষ',
    expiry_date: 'সমাপ্তির তারিখ',
    forgot: 'পাসওয়ার্ড ভুলে গেছেন?',
    group: 'দল',
    groups_list: 'দলের তালিকা',
    host: 'পরিচালক',
    id_annotation: 'টিকা আইডি',
    id_quiz: 'কুইজ আইডি',
    incorrect: 'ভুল',
    interests: 'আগ্রহ',
    invited: 'আমন্ত্রিত',
    live_chat: 'সরাসরি আলোচনা',
    live_stream_limit: 'সরাসরি -স্ট্রিমিং মিনিট',
    contact_text:
      'আপনার মাসিক সরাসরি -স্ট্রিমিং সীমাটি পরিবর্তন করতে দয়া করে যোগাযোগ করুন',
    contact_admin:
      '<0>আপনি যদি নিজের মাসিক লাইভ স্ট্রিমিং সীমাটি পরিবর্তন করতে চান তবে যোগাযোগ করুন</0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      'সরাসরি স্ট্রিমিং মিনিট বাকি: <0>{{ সীমা }}</0> মিনিট<1/><2/> <3>আপনার মাসিক সরাসরি -স্ট্রিমিং সীমাটি পরিবর্তন করতে দয়া করে যোগাযোগ করুন</3> <4>admin@sharelook.com</4>',
    location: 'অবস্থান',
    lessons: 'পাঠ্যধারা গুলি',
    location_broadcast: 'পরিচালনাকারী সার্ভারের অবস্থান',
    location_broadcast_subtitle:
      'অডিওভিজুয়াল দেরি কমাতে সম্প্রচার পরিচালনাকারীর অবস্থানের নিকটতম এমন একটি অবস্থান যুক্ত করুন',
    media_manager: 'মিডিয়া পরিচালক',
    minutes: 'মিনিট',
    name: ' নাম ',
    online_quiz: 'অনলাইন কুইজ',
    organiser: ' লেখক ',
    organization: 'সংগঠন',
    overall_emotion: 'সার্বিক অভিজ্ঞতা:',
    organizations_list: 'প্রতিষ্ঠানের তালিকা',
    password: 'পাসওয়ার্ড',
    participants: 'অংশগ্রহণকারী',
    picture: 'ছবি (১৬: ৯)',
    phone: 'ফোন',
    photo: 'ছবি',
    poll: 'ভোটগ্রহণ',
    position: 'অবস্থান',
    processing: 'প্রক্রিয়াজাতকরণ',
    privacy_settings: 'নিরাপত্তা নির্দিষ্টকরণ',
    question: 'প্রশ্ন',
    quiz_create: 'নতুন কুইজ তৈরি করুন',
    quiz_name: 'কুইজের নাম',
    quiz_update: 'আপডেট কুইজ',
    select_organization: 'একটি সংস্থা নির্বাচন করুন',
    settings: 'সেটিংস',
    show: 'প্রদর্শন',
    show_graph: 'গ্রাফ ফলাফল দেখান',
    signin: 'সাইন ইন করুন',
    signup: 'নিবন্ধন করুন',
    sort_by: 'ক্রমানুসার',
    start_date: 'শুরুর তারিখ',
    tags: ' ট্যাগ',
    terms: 'আমি সম্মত এই <1> শর্তাবলী এবং শর্ত এর সাথে </ 1>।',
    title: 'শিরোনাম',
    topics: 'বিষয় গুলো ',
    topic: 'বিষয়',
    total_comments: 'মোট মন্তব্য',
    username: 'ব্যবহারকারীর নাম',
    users_list: 'ব্যবহারকারীদের তালিকা',
    users_emails: 'নির্দিষ্ট ব্যবহারকারীদের ইমেল প্রবেশ করান ',
    description_specifiction_email:
      'দয়া করে একাধিক নির্দিষ্ট ব্যবহারকারীর সাথে এটি ভাগ করতে প্রতি লাইনে 1 টি ইমেল ঠিকানা দিন',
    message_specific_email:
      'দয়া করে নির্দিষ্ট ব্যবহারকারীর একটি ইমেল প্রবেশ করান',
    viewers: 'দর্শক',
    edit_course: 'সম্পাদনা',
    edit_assessment: 'সম্পাদনা',
    edit_event: 'সম্পাদনা',
    delete_course: 'মুছে ফেলা',
    delete_event: 'মুছে ফেলা',
    delete_assessment: 'মুছে ফেলা',
    view_course: 'দেখুন',
    view_event: 'দেখুন',
    view_assessment: 'দেখুন',
    date_event: 'লাইভ ইভেন্টের তারিখ',
    date_assessment: 'লাইভ মূল্যায়নের তারিখ',
    clone_of: 'ক্লোন',
    clone_course:
      'এই কোর্সের একটি ক্লোন তৈরি করুন যা আপনি আসলটি থেকে স্বতন্ত্রভাবে সংশোধন করতে পারবেন, এতে সমস্ত পাঠ এবং পৃষ্ঠা অন্তর্ভুক্ত করা রয়েছে',
    make: 'তৈরি',
    available_to: 'যে কোনও শেয়ারলুক ব্যবহারকারীর জন্য উপলব্ধ',
    uploaded_by: 'আপলোড করেছেন:',
    course: 'কোর্স',
    assessment: 'মূল্যায়ন',
    user_not_exist:
      'ব্যবহারকারীর অস্তিত্ব নেই, আপনি কি আমন্ত্রণ প্রেরণ করতে চান?',
    check_user: 'নোটিশ',
    user_not_exist_in_org:
      'এই সংস্থাটিতে ব্যবহারকারীর অস্তিত্ব নেই, আপনি কি একটি আমন্ত্রণ প্রেরণ করতে চান?',
    title_modal_stream: 'সংগঠনের লাইভস্ট্রিম সীমা পরিবর্তন করুন',
    des_warning_stream: 'আপনি পরিবর্তন করতে চলেছেন',
    monthly_stream: 'মাসিক লাইভ-স্ট্রিমিং সীমা:',
    min_per_month: 'মিনিট / মাস',
    broadcast_label: 'আমি করতে চাই:',
    hosts_emails: ` নির্দিষ্ট পরিচালকের ইমেল প্রবেশ করান `,
    attendee_emails: ` নির্দিষ্ট অংশগ্রহণকারীর ইমেল প্রবেশ করান `,
    description_host_specifiction_email:
      'দয়া করে প্রতি লাইনে 1 টি ইমেল ঠিকানা লিখুন।',
    presenter_label: 'উপস্থাপক',
    presenter_label_conference: 'না। মানুষ',
    event_privacy: 'কনফারেন্স ধরণ'
  },

  broadcastOptions: {
    stream_from_phone: 'আমার ফোনের সাথে সরাসরি সম্প্রচার',
    other_webrtc: ' আমার পিসি থেকে ওয়েবিনার ',
    multihost: 'আমার পিসি থেকে মাল্টিকাস্ট ওয়েবিনার',
    peer2peer: 'কোচিং এর কাল',
    conference: 'সরাসরি আলাপ-আলোচনা'
  },

  lessoncreate: {
    title: 'পাঠের বিবরণ যুক্ত করুন',
    subtitle:
      'আপনার পাঠের নাম দিন এবং আপনার শ্রোতাদের এ থেকে কী শিখার আশা করা উচিত তা বলুন',
    input_label_title: 'পাঠের শিরোনাম',
    input_label_topics: 'পাঠের বিষয়',
    input_label_description: 'পাঠের বিবরণ',
    delete_warning: 'আপনি কি নিশ্চিত যে আপনি এই পৃষ্ঠাটি মুছতে চান?'
  },

  lessonoverview: {
    title: 'পাঠ যোগ করুন',
    subtitle: 'বিদ্যমান পাঠ যোগ করুন বা একটি নতুন তৈরি করুন',
    new_lesson: 'একটি নতুন পাঠ তৈরি করুন',
    new_lesson_sub: 'স্ক্র্যাচ থেকে একেবারে নতুন পাঠ তৈরি করুন!',
    existing_lesson: 'বিদ্যমান পাঠ নির্বাচন করুন',
    existing_lesson_sub:
      'বিদ্যমান পাঠের সাথে লিঙ্ক, এই পাঠ্যক্রমের পরিবর্তনগুলি অন্যান্য পাঠ্যক্রমগুলিতেও এই পাঠকে প্রভাবিত করবে।',
    clone_lesson: 'বিদ্যমান পাঠের সদৃশ',
    clone_lesson_sub:
      'এই কোর্সে পাঠের একটি অনন্য অনুলিপি তৈরি করুন, এই পাঠ্যে করা পরিবর্তনগুলি মূল পাঠকে প্রভাবিত করবে না।',
    clone_lesson_modal_sub:
      'আপনি যে পাঠ্যক্রমটিতে যোগ করতে চান দয়া করে নীচের ক্লোন বোতামটি ক্লিক করুন।'
  },

  management: {
    groups_title: 'দল পরিচালনা',
    delete_warning: 'তুমি কি নিশ্চিত?',
    organizations_title: 'আমার সংস্থা',
    organizations_subtitle: 'আপনার তালিকায় সংস্থাগুলি যুক্ত করুন',
    users_title: 'ব্যবহারকারীদের ম্যানেজ করুন',
    users_position: 'প্রবীণ অ্যাকাউন্ট ব্যবস্থাপক',
    user_not_found: 'ব্যবহারকারী খুঁজে পাওয়া যায় না',
    select_org:
      'ব্যবহারকারীদের পরিচালনা করতে দয়া করে একটি সংস্থা খুঁজে নিন এবং চয়ন করুন'
  },

  audio: {
    modal_title: 'অডিও প্রবেশ করান',
    list_view: 'তালিকা দেখুন',
    create_audio_modal_title: 'অডিও তৈরি করুন',
    edit_audio_modal_title: 'অডিও সম্পাদনা করুন',
    public_audio_not_found: 'অডিও পাওয়া যায় নি।',
    private_audio_not_found: 'আপনি এখনও কোনও অডিও আপলোড করেননি',
    are_you_sure_to_delete: 'আপনি কি নিশ্চিত মুছতে চান?',
    type_something: 'কিছু লেখো',
    select_voice: 'নির্বাচন',
    file_name: 'ফাইলের নাম',
    description: 'বিবরণ',
    topic: 'বিষয়',
    key_words_tag: 'মূল শব্দসমূহ ট্যাগ',
    mp3_audio: 'এমপি3 অডিও',
    created: 'তৈরি',
    duration: 'সময়কাল',
    close: 'বন্ধ'
  },

  image: {
    modal_title: 'চিত্র প্রবেশ করান',
    image: 'চিত্র',
    pixel: ' পিক্সেল ',
    dimension: 'মাত্রা',
    public_image_not_found: 'ছবিটি খুঁজে পাওয়া যায়নি.',
    private_image_not_found: 'আপনি এখনও কোনও চিত্র আপলোড করেননি'
  },

  annotation: {
    modal_title: 'টিকা'
  },

  text: {
    modal_title: 'টেক্সট সম্পাদক'
  },

  video: {
    modal_title: 'ভিডিওপ্রবেশ করান',
    image: 'ভিডিও',
    mp4_video: 'এমপি 4 ভিডিও',
    public_video_not_found: 'ভিডিও পাওয়া যায় না.',
    private_video_not_found: 'আপনি এখনও কোনও ভিডিও আপলোড করেননি'
  },

  media: {
    title: 'মিডিয়া লাইব্রেরি',
    subtitle: 'আপনার ফাইলগুলির লাইব্রেরি',
    modal_title: 'আপলোড মিডিয়া',
    delete_warning: 'নিশ্চিত বাতিল',
    delete_message:
      'মুছে ফেলা মিডিয়াগুলি এখনও তাদের যে পৃষ্ঠাগুলি ব্যবহার করা হয়েছিল সেখানে উপস্থিত হবে',
    dropzone_text: 'বা টেনে আনুন এবং ফেলে দিন',
    delete_success: 'মিডিয়া সফলভাবে মুছে ফেলা হয়েছে',
    upload_file: 'ফাইল আপলোড করুন',
    drag_drop: 'বা টেনে আনুন এবং ফেলে দিন',
    import_file: 'আপনার কম্পিউটার থেকে ফাইল (গুলি) আমদানি করুন',
    no_media: 'আপনি এখনও কোনও মিডিয়া আপলোড করেননি',
    media_type: 'মিডিয়া ধরন ',
    video: 'ভিডিও',
    transcribed_text: 'Transcribed Text',
    image: 'চিত্র',
    audio: 'অডিও',
    gif: 'গ্রাফিক্স ইন্টারচেঞ্জ ফরম্যাট',
    media_not_found: 'মিডিয়া খুঁজে পাওয়া যায়নি।',
    of: 'এর',
    disclaimer: ` আমি আশ্বাস দিয়েছি যে আমার মিডিয়া তা করে না:
    - যে কোন তৃতীয় পক্ষের অধিকার লঙ্ঘন
    - মানহানি সহ, অশ্লীল, অশোভন, দুশ্চরিত্র, অশ্লীল রচনা চিত্র, উগ্র, গালিগালাজপূর্ণ, অপমানকর, হুমকি দেওয়া বা বৈষম্যমূলক বিষয়বস্তু সহ এমন কোনও অবৈধতা রয়েছে, এমনকি তারকাচিহ্ন দ্বারা ছদ্মবেশযুক্ত
    - অন্যান্য ব্যক্তির উপর কোনও ব্যক্তিগত আক্রমণ রয়েছে
    - অন্যান্য অংশগ্রহণকারী, জনসাধারণের ব্যক্তিত্ব বা সেলিব্রিটিদের কোনও ছদ্মবেশ ধারণ করে
    - এই জাতীয় ব্যক্তির সম্মতি ব্যতীত যে কোনও ব্যক্তির কোনও রেকর্ডিং বা ব্যক্তিগত তথ্য থাকতে পারে এবং বিশ্বের কোন অংশে কোনও তথ্য সুরক্ষা নিয়ন্ত্রণের লঙ্ঘন করছে না
    - যে কোনও বাণিজ্যিক আবেদন বা কোন রকম "স্প্যাম" ধারণ করে”`,
    my_media: 'আমার মিডিয়া',
    public_library: 'গণ গ্রন্থাগার',
    organization_library: 'সংস্থা লাইব্রেরি',
    upload_from_computer: 'কম্পিউটার থেকে আপলোড',
    create: 'সৃষ্টি',
    all: 'সব',
    male: 'পুরুষ',
    female: 'মহিলা',
    processing_audio: 'অডিও প্রসেসিং ',
    create_annotation: 'টীকা তৈরি করুন',
    popup_over_lesson_text: 'টীকাগুলি ক্লিকের পরে পাঠ পৃষ্ঠাতে পপ আপ হবে',
    edit_detail: 'বিশদটি সম্পাদনা করুন',
    delete: 'মুছে ফেলা',
    go_create_audio: 'অডিও তৈরি করুন',
    show_more_details: 'আরও বিশদ প্রদর্শন করুন',
    show_less_details: 'কম বিশদ দেখান',
    drop_files: 'ফাইলগুলি ড্রপ করুন এবং আপলোড করুন',
    or: 'বা',
    import_files: 'কম্পিউটার থেকে ফাইল আমদানি করুন'
  },

  navigation: {
    account: 'অ্যাকাউন্ট',
    assessments: 'মূল্যায়ন',
    dashboard: 'ড্যাশবোর্ড',
    groups: ' গ্রুপ পরিচালনা ',
    logout: ' প্রস্থান',
    organisations: 'সংস্থা',
    organizations_users: 'সংস্থা ও ব্যবহারকারী',
    reports: 'রিপোর্ট',
    schedule: 'তফসিল',
    nowLive: 'সরাসরি সম্প্রচার',
    training: 'প্রশিক্ষণ',
    users: 'ব্যবহারকারী',
    workshop: 'আমার কর্মশালা'
  },

  onboarding: {
    step1_title: 'পদক্ষেপ ১: নিজের সম্পর্কে আমাদের একটু বলুন',
    step1_subtitle: 'আপনার নাম কি? আপনি কোথা থেকে আসছো? আপনার পদমর্যাদা কি?',
    step2_title:
      'পদক্ষেপ ২: আপনি উন্নত করতে পারেন এমন কিছু দক্ষতা নির্বাচন করুন',
    step2_subtitle:
      'এরপরে, আপনি কী আরও ভালভাবে বুঝতে চান তা আমাদের বলুন।সম্ভবত আপনার এখনও বাছাই কিছু আছে?? পড়াশোনার নতুন ক্ষেত্র? আপনার প্রিয়জন কি করেন?'
  },

  pagebuilder: {
    title: 'পাঠ তৈরি করুন',
    subtitle:
      'আপনার কাছ থেকে শেখার জন্য দর্শকদের জন্য সামগ্রী তৈরি করার সময়, আপনি ছবি, ভিডিও এবং ইনফোগ্রাফিক্স করতে পারেন',
    select_layout: 'একটি পৃষ্ঠা বিন্যাস নির্বাচন করুন',
    template1: 'ফাঁকা',
    template2: 'শিরোনাম & উপশিরোনাম',
    template3: 'শিরোনাম & পাঠ্য',
    template4: 'শিরোনাম, মিডিয়া & পাঠ্য',
    template5: 'শিরোনাম & মিডিয়া',
    template6: 'শিরোনাম & কুইজ'
  },

  pageconstructor: {
    title: 'পাঠ তৈরি করুন এবং ক্লোন করুন',
    subtitle:
      'আপনার কাছ থেকে শেখার জন্য দর্শকদের জন্য সামগ্রী তৈরি করার সময়, আপনি ছবি, ভিডিও এবং ইনফোগ্রাফিকগুলি যুক্ত করতে পারেন'
  },

  passwordreset: {
    success_coded:
      'আপনার প্রদত্ত ঠিকানায় আমরা একটি নিশ্চিতকরণ কোড ইমেল করেছি, দয়া করে একটি নতুন পাসওয়ার্ড সেট করতে নীচের ক্ষেত্রটিতে কোডটি অনুলিপি করুন।',
    success_changed:
      'আপনি সফলভাবে একটি নতুন পাসওয়ার্ড সেট করেছেন। আপনি এখন সাইন ইন করতে পারেন।'
  },

  placeholders: {
    search: 'অনুসন্ধান',
    answer: 'উত্তর',
    chat: 'কিছু বল...',
    code: 'কোড',
    criterion: 'মানদণ্ড',
    date_event: 'তারিখ & সময় নির্বাচন করুন',
    date_start: ' শুরুর তারিখ',
    date_expire: 'সমাপ্তির তারিখ',
    description: 'বিবরণ',
    elements: 'উপাদান বাছাই করুন',
    email: 'ইমেল',
    feedback_correct: 'প্রতিক্রিয়া সঠিক',
    feedback_incorrect: 'প্রতিক্রিয়া ভুল',
    host: ' উপস্থাপক ',
    keywords: 'কীওয়ার্ড (গুলি) অনুসন্ধান',
    lesson_description: 'পাঠের বিবরণ',
    location: 'অবস্থান',
    minutes: 'মিনিট',
    name: 'নাম',
    organiser: 'লেখক',
    organization: 'সংগঠন',
    password: 'পাসওয়ার্ড',
    phone: 'ফোন',
    photo: 'ছবি',
    picture: 'ছবি',
    point: 'পয়েন্ট',
    position: 'অবস্থান',
    question: 'প্রশ্ন',
    quiz: 'কুইজের নাম',
    search_course: 'কোর্স দ্বারা অনুসন্ধান',
    search_media: 'মিডিয়া অনুসন্ধান ',
    search_name: 'নাম দ্বারা অনুসন্ধান',
    search_title: 'শিরোনাম অনুসারে অনুসন্ধান করুন',
    search_training: 'অনুসন্ধান',
    settings: 'সেটিংস',
    tags: 'ট্যাগ',
    title: 'শিরোনাম',
    topics: 'বিষয়',
    username: 'ব্যবহারকারীর নাম',
    keyword: 'কীওয়ার্ডস',
    max_500_characters: 'সর্বোচ্চ ৫০০ টি অক্ষর ',
    no_description: 'এই ফাইলটির কোনও বিবরণ নেই',
    no_keyword: 'এই ফাইলটির কোনও কীওয়ার্ড নেই',
    no_topics: 'এই ফাইলটিতে কোন বিষয় সেট করা নেই',
    feedback: 'বার্তা',
    contact: 'আমরা কীভাবে সাহায্য করতে পারি?'
  },

  publishsettings: {
    title: 'প্রকাশিত সেটিংস',
    event_subtitle:
      'আপনার ইভেন্টে সেটিংস যুক্ত করুন, যারা আপনার ইভেন্টটি দেখতে ও তার সাথে ইন্টারঅ্যাক্ট করতে পারে',
    assessment_subtitile:
      'আপনার মূল্যায়নের নাম দিন এবং আপনার শ্রোতাদের এ থেকে কী শিখার আশা করা উচিত তা বলুন ',
    course_subtitle:
      'আপনার কোর্সে সেটিংস যুক্ত করুন, কে আপনার পাঠ্যক্রমটি দেখতে এবং তার সাথে ইন্টারঅ্যাক্ট করতে পারে',
    disclaimer: `1.	নিবন্ধন

  একজন ব্যবহারকারী হিসাবে নিবন্ধন করে / একটি অ্যাকাউন্ট তৈরি করে আপনি আমাদের [ব্যবহারকারীর চুক্তিতে] সম্মত হন এবং আমাদের [গোপনীয়তা নীতি] পড়ার বিষয়টি স্বীকার করেন


  2.	কোর্স তৈরি করুন

  আমাদের সরঞ্জামগুলি ব্যবহার করে এবং কোর্স সামগ্রী তৈরি করে আপনি আমাদের [ব্যবহারকারীর চুক্তিতে] সম্মত হন এবং আমাদের [গোপনীয়তা নীতি] পড়ার বিষয়টি স্বীকার করেন


  3.	ইভেন্ট তৈরি

  আমাদের সরঞ্জামগুলি ব্যবহার করে এবং একটি ইভেন্ট তৈরি করে আপনি আমাদের [ব্যবহারকারীর চুক্তিতে] সম্মত হন এবং আমাদের [গোপনীয়তা নীতি] পড়ার বিষয়টি স্বীকার করেন

  4.	মূল্যায়ন তৈরি

  আমাদের সরঞ্জামগুলি ব্যবহার করে এবং একটি মূল্যায়ন তৈরি করে আপনি আমাদের [ব্যবহারকারীর চুক্তিতে] সম্মত হন এবং আমাদের [গোপনীয়তা নীতি] পড়ার বিষয়টি স্বীকার করেন`,
    dates_validation_error: 'উভয় তারিখ পূরণ করা উচিত।',
    emails_validation_error: 'ইমেল তালিকাটি অবৈধ।',
    specific_email_validation_error: 'কেবল একটি ইমেল অনুমোদিত।',
    i_agree_to_these: 'আমি এগুলির সাথে একমত ',
    terms_and_conditions: 'শর্তাদি & শর্তাবলী.',
    PublicDescription: `বিনামূল্যে স্বাধীন ব্যবহারকারী: (ব্যক্তিগত এবং পাবলিক বিকল্প) আপনার [কোর্স | ইভেন্ট | মূল্যায়ন] সংরক্ষণ করা হয়েছে এবং এটি ডিফল্টরূপে ব্যক্তিগত হিসাবে বিবেচনা করা হয়। এর অর্থ হ'ল কেবল আপনি এই সামগ্রীটি দেখতে পারবেন। এই সামগ্রীটি প্রকাশ করার জন্য আপনি নীচে সর্বজনীন নির্বাচন করতে পারেন। এর অর্থ হল এই কোর্সটি প্ল্যাটফর্মের সমস্ত ব্যবহারকারীর জন্য উপলব্ধ হবে। `,
    OrganisationsDescription: `প্রতিষ্ঠানের ব্যবহারকারীরা: ((পরিবর্তে"" সমাপ্ত "" ব্যবহার "" প্রকাশ করুন ""এবং এটিকে অন্য ব্যবহারকারীর মতো প্রকাশের পৃষ্ঠায় নিয়ে আসুন তবে প্রকাশের কোনও বিকল্প ছাড়াই।)আপনার [কোর্স | ইভেন্ট | মূল্যায়ন] সংরক্ষণ করা হয়েছে এবং এটি ব্যক্তিগত। এর অর্থ হ'ল কেবলমাত্র আপনি এবং আপনার প্রতিষ্ঠানের প্রশাসকরা এটি দেখতে পারবেন।একজন ব্যবহারকারী হিসাবে, আপনি নিজের সংস্থাগুলির মধ্যেই আপনার সামগ্রী প্রকাশ করতে সক্ষম হবেন না কারণ এর জন্য প্রশাসকের অধিকারের প্রয়োজন হয়। দয়া করে আপনার প্রশাসকের একজনের সাথে যোগাযোগ করুন এবং তাদের আপনার সামগ্রীতে প্রকাশ্যভাবে পুরো সংস্থাতে, আপনার সংস্থার নির্দিষ্ট গ্রুপগুলিতে বা নির্দিষ্ট ব্যবহারকারীদের কাছে প্রকাশ করতে বলুন।`,
    OrganisationGroupsDescription: `সংস্থা প্রশাসন: (প্রতিষ্ঠানের মধ্যে তৈরি সামগ্রীর জন্য: ব্যক্তিগত, পাবলিক, সংস্থা, গ্রুপ, নির্দিষ্ট ব্যবহারকারী):এই [কোর্স | ইভেন্ট | মূল্যায়ন] সংরক্ষণ করা হয়েছে এবং এটি ডিফল্টরূপে ব্যক্তিগত হিসাবে বিবেচনা করা হয়। এর অর্থ হ'ল কেবলমাত্র আপনি (এবং সামগ্রী স্রষ্টা) এই সামগ্রীটি দেখতে পাচ্ছেন। এই সামগ্রী প্রকাশ করার জন্য আপনি নীচের বিকল্পগুলির মধ্যে একটি নির্বাচন করতে পারেন। আপনার পাঠ্যক্রমটি জনসমক্ষে প্রকাশ করার অর্থ এটি আপনার সংস্থার বাইরের অংশগুলি সহ - প্ল্যাটফর্মের সমস্ত ব্যবহারকারীদের কাছে উপলব্ধ। এটি সংস্থায় প্রকাশ করার অর্থ হ'ল সংস্থার মধ্যে থাকা সমস্ত ব্যবহারকারীরা এটি দেখতে সক্ষম হবেন।আপনি এটি ১ বা একাধিক গোষ্ঠীতে প্রকাশ করতে পারেন, যার অর্থ কেবলমাত্র সেই গোষ্ঠীর মধ্যে থাকা ব্যবহারকারীরা এটি দেখতে সক্ষম হবেন। শেষ অবধি, আপনার নিজের প্রতিষ্ঠানের ভিতরে এবং বাইরে নির্দিষ্ট ব্যবহারকারীদের কাছে তাদের শেয়ারলুক অ্যাকাউন্ট ইমেল ঠিকানা ব্যবহার করে প্রকাশ করার বিকল্প রয়েছে।`,
    SpecificUsersDescription: `পরিশোধিত স্বতন্ত্র ব্যবহারকারী: (ব্যক্তিগত, সরকারী এবং নির্দিষ্ট ব্যবহারকারী)আপনার [কোর্স | ইভেন্ট | মূল্যায়ন] সংরক্ষণ করা হয়েছে এবং এটি ডিফল্টরূপে ব্যক্তিগত হিসাবে বিবেচনা করা হয়। এর অর্থ হ'ল কেবল আপনি এই সামগ্রীটি দেখতে পারবেন। এই সামগ্রী প্রকাশ করার জন্য আপনি নীচের বিকল্পগুলির মধ্যে একটি নির্বাচন করতে পারেন।আপনার পাঠ্যক্রমটি সর্বজনীনে প্রকাশ করার অর্থ এটি প্ল্যাটফর্মের সমস্ত ব্যবহারকারীর জন্য উপলব্ধ। নির্দিষ্ট ব্যবহারকারীদের বিকল্প আপনাকে নির্দিষ্ট ব্যবহারকারীদের সাথে তাদের শেয়ারলোক অ্যাকাউন্টের সাথে সম্পর্কিত ইমেল ঠিকানা ব্যবহার করে আপনার কোর্স ভাগ করতে সক্ষম করবে।' }`,

    quiz: {
      quiz_empty: 'আপনি এখনও একটি কুইজ তৈরি করেন নি',
      questions_empty: 'আপনি এখনও একটি প্রশ্ন তৈরি করেন নি'
    },

    regions: {
      asia_pacific_australia: 'অস্ট্রেলিয়া',
      asia_pacific_india: 'ভারত',
      asia_pacific_japan: 'জাপান',
      asia_pacific_s_korea: 'দক্ষিণ কোরিয়া',
      asia_pacific_singapore: ' সিঙ্গাপুর ',
      asia_pacific_taiwan: 'তাইওয়ান',
      eu_belgium: 'বেলজিয়াম',
      eu_germany: 'জার্মানি',
      eu_ireland: 'আয়ারল্যান্ড',
      south_america_brazil: 'ব্রাজিল',
      us_central_iowa: 'আইওয়া',
      us_east_s_carolina: 'দক্ষিণ ক্যারোলিনা',
      us_east_virginia: 'ভার্জিনিয়া',
      us_west_california: 'ক্যালিফোর্নিয়া',
      us_west_oregon: 'ওরেগন'
    },

    reports: {
      title: 'প্রতিবেদন',
      workshop_report: 'কর্মশালা  বিবরণ',
      user_report: ' ব্যবহারকারী বিবরণ',
      organization_workshop: 'প্রতিষ্ঠানের কর্মশালা ',
      course: ' কোর্স ',
      live_event: 'সরাসরি ঘটনা',
      workShop_graph: 'কর্মশালা গ্রাফ',
      organization_account: 'সংস্থার হিসাব',
      all: ' সব ',
      name: 'নাম',
      id_number: 'আইডি নাম্বার',
      email: 'ইমেল',
      search_user_report: 'ব্যবহারকারী প্রতিবেদন অনুসন্ধান করুন',
      participant: 'অংশগ্রহণকারী',
      participants: 'অংশগ্রহণকারীরা',
      host: 'উপস্থাপক',
      username: 'ব্যবহারকারীর নাম',
      event: 'ঘটনা',
      quiz: 'কুইজ',
      assessment: 'মূল্যায়ন',
      time: 'সময়',
      no_recent_activity: 'কোনও সাম্প্রতিক কার্যকলাপ নেই',
      workshops: 'কর্মশালা',
      courses: 'পাঠ্যধারাগুলি',
      live_events: 'সরাসরি অনুষ্ঠান',
      live_assessments: 'সরাসরি মূল্যায়ন',
      quizzes: 'কুইজস',
      overview: 'পরিদর্শন',
      by: 'দ্বারা',
      views: 'দর্শন',
      status: 'স্থিতি',
      poll: 'ভোটগ্রহণ',
      comment: 'মন্তব্য',
      comments: 'মন্তব্য',
      no_comments: 'কোন মন্তব্য নেই',
      no_polls: 'কোনও পোল নেই',
      live_date: 'লাইভ তারিখ',
      score: 'স্কোর',
      question: 'প্রশ্ন',
      submit: 'জমা দিন',
      recent_activity: 'সাম্প্রতিক কার্যকলাপ',
      ago: 'আগে',
      no_data_found: 'কোনও ডেটা পাওয়া যায় নি',
      start_end_live: 'লাইভ শুরু / শেষ করুন',
      join_leave_date: `যোগদান / ছেড়ে দিন'`,
      watched_time: 'প্রহরী সময়',
      complete: 'সম্পূর্ণ',
      in_complete: 'অসম্পূর্ণ',
      today: 'আজ',
      seven_days: '7 দিন',
      last_month: 'গত মাসে',
      one_year: '1 বছর',
      all_time: 'সব সময়',
      report: 'প্রতিবেদন',
      from_date: 'তারিখ হইতে',
      to_date: 'এখন পর্যন্ত',
      all_workshop: 'সমস্ত কর্মশালা',
      all_participants: 'সমস্ত অংশগ্রহণকারী',
      live_assessment: 'সরাসরি মূল্যায়ন',
      users: 'ব্যবহারকারীরা',
      download: 'ডাউনলোড করুন',
      recent: 'সাম্প্রতিক',
      WorkShop: 'কর্মশালা',
      Activity: 'ক্রিয়াকলাপ',
      created_date: 'তৈরীর তারিখ',
      lessons: 'পাঠ',
      lesson: 'পাঠ',
      completed: 'সমাপ্ত',
      report_download: 'রিপোর্ট ডাউনলোড',
      this_month: 'এই মাস',
      search_course: 'কোর্স অনুসন্ধান',
      participants_graph: 'অংশগ্রহণকারীদের গ্রাফ',
      viewed: 'দেখা হয়েছে',
      enrolled: 'তালিকাভুক্ত',
      description: 'বর্ণনা',
      topic: 'বিষয়',
      analytic: 'বিশ্লেষক',
      quiz_list: 'কুইজ তালিকা',
      select_one: 'একটা নির্বাচন করুন',
      group_status: 'গ্রুপের অবস্থা',
      duration_min: 'সময়কাল (মিনিট)',
      submit_poll: ' ভোট জমা দিন',
      download_events: 'ইভেন্টগুলি ডাউনলোড করুন',
      search_event: 'ইভেন্ট অনুসন্ধান',
      duration: 'সময়কাল',
      total_participants: 'মোট অংশগ্রহণকারীরা',
      message: 'বার্তা',
      avg_message: 'গড় বার্তা',
      per_message: 'বার্তা / ইভেন্টের একটি স্থিরতা'
    },

    signup: {
      success_step1:
        'আপনার সরবরাহিত ঠিকানায় আমরা একটি যাচাইকরণ কোড ইমেল করেছি, দয়া করে আপনার নিবন্ধকরণটি নিশ্চিত করতে নীচের ক্ষেত্রের মধ্যে কোডটি অনুলিপি করুন।',
      success_step2: 'ধন্যবাদ আপনি সফলভাবে নিবন্ধিত।',
      privacy: ` আমি সম্মত শেয়ারলুকের <1> শর্তাবলী & শর্ত </1> এবং <3> গোপনীয়তা নীতিতে </3>`
    },

    stream: {
      emotion_impressive: 'চিত্তাকর্ষক',
      emotion_unimpressive: 'আকর্ষণহীন',
      message_not_started: 'শীঘ্রই আসছে',
      message_running: 'সরাসরি',
      message_processing:
        'আমরা বর্তমানে প্লেব্যাকের জন্য লাইভ রেকর্ডিং প্রক্রিয়াজাত করছি। ভিডিওটি দেখতে এবং রেটিং এবং প্রতিক্রিয়া যোগ করে যেতে দয়া করে পরে আবার চেক করুন'
    },

    tabs: {
      audience: 'শ্রোতা',
      course: 'কোর্স পরিদর্শন ',
      details: 'সরাসরি ইভেন্টের বিবরণ',
      description: 'বর্ণনা',
      host: 'উপস্থাপক',
      lesson: 'পাঠ পরিদর্শন',
      lessons: 'পাঠ',
      overview: 'পরিদর্শন',
      page: 'পৃষ্ঠা নির্মাতা',
      publish: 'প্রকাশ',
      settings: 'সেটিং প্রকাশ করুন',
      total_views: ' সব দেখা',
      live_participates: 'সরাসরি অংশগ্রহণকারী',
      live_chats: 'সরাসরি চ্যাট',
      live_quiz: 'সরাসরি ভোটগ্রহণ',
      trainer_rating: 'ট্রেনার রেটিং',
      trainer_times: 'ট্রেনার সময়',
      courses_quizzes: 'কোর্স কুইজ',
      user_list: 'ব্যবহারকারীর তালিকা',
      discussion: 'আলোচনা',
      notes: 'আমার নোট'
    },

    topics: {
      SALES_TRAINING: 'বিক্রির প্রশিক্ষণ',
      NEGOTIATION_TRAINING: 'আলোচনার প্রশিক্ষণ',
      CROSS_CULTURAL_AWARENESS: 'আন্তঃ-সাংস্কৃতিক সচেতনতা',
      NETWORKING_SKILLS: 'নেটওয়ার্কিং দক্ষতা',
      SOFTWARE_ARCHITECTURE: 'সফটওয়্যার আর্কিটেকচার',
      PROJECT_MANAGEMENT: 'প্রকল্প পরিচালনা',
      DIGITAL_TRANSFORMATION: 'ডিজিটাল রূপান্তর',
      IT_CONSULTING: 'আইটি পরামর্শদাতা',
      MANAGEMENT_CONSULTING: 'ব্যবস্থাপনা পরামর্শ',
      HR_CONSULTING: 'এইচআর পরামর্শদাতা',
      INTERNET_OF_THINGS: 'ইন্টারনেট অফ থিংস (আইওটি)',
      CYBERSECURITY: 'সাইবার নিরাপত্তা',
      PRIVACY_AND_GDRP: 'গোপনীয়তা এবং সাধারণ তথ্য সুরক্ষা নিয়ন্ত্রণ'
    },

    training: {
      title: 'প্রশিক্ষণ',
      title_assessment: 'মূল্যায়ন',
      subtitle: 'কোর্স এবং সরাসরি ইভেন্ট',
      enrolled_title: 'তালিকাভুক্ত কোর্স এবং সরাসরি ইভেন্ট',
      enrolled_subtitle: 'আপনার নথিভুক্ত লাইভ ইভেন্টগুলি এবং কোর্স ',
      enrolled_message: 'আপনি বর্তমানে কোনও কোর্স এবং ইভেন্টে ভর্তি নন।',
      past_live_event_title: 'বিগত সরাসরি ইভেন্ট',
      past_live_event_subTitle: 'সমাপ্ত লাইভ ইভেন্ট',
      past_live_event: 'বর্তমানে কোনও বিগত লাইভ ইভেন্ট নেই',
      recomended_title: 'প্রস্তাবিত কোর্স এবং সরাসরি ইভেন্ট',
      now_live_event_title: 'এখন সরাসরি ',
      now_live_event_subTitle: 'ইভেন্টগুলি সরাসরি বা খুব শীঘ্রই হবে',
      now_live_event: 'বর্তমানে কোনও সরাসরি ইভেন্ট নেই',
      webinar_event_title: 'ওয়েবিনার চ্যানেল',
      webinar_event_subTitle: 'সমাপ্ত ওয়েবিনারস',
      webinar_event: 'বর্তমানে কোনও ওয়েবিনার নেই',
      p2p_event_title: 'কোচিং এর সময়কাল',
      p2p_event_subTitle: 'সমাপ্ত কোচিং এর সময়কাল',
      p2p_event: 'বর্তমানে কোনও কোচিং সেশন নেই।',

      now_live_assessment_title: 'এখন সরাসরি',
      now_live_assessment_subTitle: 'মূল্যায়ন যা সরাসরি হয় বা খুব শীঘ্রই হবে',
      now_live_assessment_message: 'বর্তমানে কোনও সরাসরি মূল্যায়ন নেই',

      upcoming_assessment_title: 'আসন্ন সরাসরি মূল্যায়ন',
      upcoming_assessment_subtitle: 'আসন্ন সরাসরি মূল্যায়ন',
      upcoming_assessment_message: 'বর্তমানে কোনও আসন্ন সরাসরি মূল্যায়ন নেই।',

      past_live_assessment_title: 'বিগত সরাসরি মূল্যায়ন',
      past_live_assessment_subTitle: 'সমাপ্ত লাইভ মূল্যায়ন',
      past_live_assessment_message: 'বর্তমানে কোনও অতীত সরাসরি মূল্যায়ন নেই',

      /**
       * <0/> get index 0 of data from Trans component
       * exp -->
       * <Trans i18nKey='training:recomended_subtitle' >
       *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
       *    <h1>{...something}</h1> --> is index 1 of Trans component
       * </Trans>
       */
      recomended_subtitle:
        'আপনার <0><0/> </0> এর উপর ভিত্তি করে আমরা কিউরেটেড কোর্স এবং লাইভ ইভেন্ট করেছি',
      /**
       * and we also can get data from index to replace in recommended_subtitle by like above string.
       * for exp -->
       * at the end of the recomended_subtitle above will get data from index of component to display
       * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
       */
      search: 'প্রশিক্ষণ অনুসন্ধান ',
      search_assessment: 'মূল্যায়ন অনুসন্ধান ',
      recomended_message: 'বর্তমানে কোনও প্রস্তাবিত কোর্স এবং ইভেন্ট নেই।'
    },

    warnings: {
      delete: 'তুমি কি নিশ্চিত?'
    },

    workshop: {
      title: 'আমার কর্মশালা',
      subtitle:
        'একটি কোর্স তৈরি করুন বা আপনার নিজের একটি সরাসরি ইভেন্ট হোস্ট করুন',
      new_course: 'একটি নতুন কোর্স তৈরি করুন',
      new_event: 'একটি নতুন সরাসরি ইভেন্ট তৈরি করুন',
      new_assessment: 'একটি নতুন সরাসরি মূল্যায়ন তৈরি করুন',
      courses_title: 'তৈরি কোর্স & সরাসরি ইভেন্ট',
      courses_subtitle: `সম্পাদনা করুন & আপনার তৈরি কোর্সটি প্রকাশ করুন এবং সরাসরি ইভেন্টগুলির পরিকল্পনা করুন`,
      tags_course: 'কোর্স',
      tags_live: 'সরাসরি ঘটনা',
      tags_assessment: 'সরাসরি মূল্যায়ন'
    },

    help_center: {
      sidebar: {
        title: 'কিভাবে আমরা আপনাকে সাহায্য করতে পারে?',
        back_to: ' ড্যাশবোর্ড '
      },
      menu: {
        help_center: 'সাহায্য কেন্দ্র',
        whats_new: ' কী নতুন ',
        feedback: 'শেয়ারলুকে মতামত পাঠান',
        feedback_title: 'শেয়ারলুকে মতামত পাঠান',
        terms_and_conditions: 'শর্তাবলী & শর্তাদি',
        privacy_policy: 'গোপনীয়তা নীতি',
        contact_us: 'যোগাযোগ করুন'
      },
      get_started: {
        title: 'শেয়ারলুক এর সাথে শুরু করুন',
        description: {
          main: `আমরা সহজেই ব্যবহারের জন্য কোর্স বিল্ডারের সাথে সরাসরি ভিডিওটি সংযুক্ত করেছি`,
          tagline:
            'শেয়ারলুকের পেটেন্টযুক্ত লাইভ ব্রডকাস্ট সিস্টেমের সাহায্যে আপনি বাগদান তৈরি করতে পারেন, শিখনকে স্বয়ংক্রিয় করতে এবং জ্ঞান ভাগাভাগি করতে পারেন।'
        }
      },
      whats_new: {
        title: 'শেয়ারলুক এর সাথে শুরু করুন',
        description: {
          main: `আপনি কি জানেন যে গল্প বলার স্টাইল লার্নিং অল্প সময়ে তৈরি করতে পারে এবং এত ব্যয়বহুল নয়? আপনার শেয়ারলুক কোর্স নির্মাতা এবং সংশ্লিষ্ট প্রতিভা একত্রিত করা উচিত। আপনি আমাদের জিজ্ঞাসা করতে পারেন "কিভাবে"`,
          tagline: ''
        }
      },
      create_workshop: 'কিভাবে একটি ওয়ার্কশপ তৈরি করা যায়',
      create_course: 'একটি কোর্স কিভাবে তৈরি করা যায়',
      create_user: 'কীভাবে একটি ব্যবহারকারী তৈরি করা যায়',
      create_group: 'কীভাবে একটি গ্রুপ তৈরি করা যায়',
      create_webinar: 'কীভাবে ওয়েবিনার তৈরি করা যায়',
      create_live_event: 'সরাসরি ইভেন্ট কীভাবে তৈরি করা যায়',
      create_live_assessment: 'সরাসরি মূল্যায়ন কীভাবে তৈরি করা যায়',
      create_live_on_mobile: 'মোবাইলে লাইভ তৈরি করুন',
      personalize_profile: 'ব্যক্তিগতকৃত একটি প্রোফাইল ',
      manage_group: 'গ্রুপ পরিচালনা',
      report: 'রিপোর্ট',
      add_annotations: 'টিকা / পপআপ কীভাবে যুক্ত করা যায়',
      add_audio: 'কীভাবে অডিও যুক্ত করা যায়',
      add_header_and_footer: 'শিরোনাম & পাদচরণ যুক্ত করা',
      add_image: 'কীভাবে ছবি যুক্ত করা যায়',
      add_quiz_content: 'কুইজ সামগ্রী কীভাবে যুক্ত করা যায়',
      add_text_content: 'পাঠ্য সামগ্রী কীভাবে যুক্ত করা যায়',
      add_user: 'কীভাবে ব্যবহারকারী যুক্ত করা যায়',
      add_video: 'কীভাবে ভিডিও যুক্ত করা যায়',
      clone_course: 'কোর্স ক্লোন কিভাবে',
      find_live_broadcast: 'সরাসরি ব্রডকাস্ট কীভাবে সন্ধান করবেন',
      contact_us: {
        title: 'যোগাযোগ করুন',
        subject_placeholder: 'একটি বিষয় লিখুন *',
        content_placeholder: 'একটি বার্তা লিখুন *',
        subject_required: '* বিষয় প্রয়োজন ',
        content_required: '* বার্তা প্রয়োজন ',
        submit: 'প্রেরণ',
        cancel: 'বাতিল',
        sent: 'প্রেরিত'
      },
      feedback: {
        title: ' মতামত শেয়ার করুন শেয়ারলুকে ',
        attach_title: 'একটি নথি যোগ করুন',
        choose: 'ফাইল পছন্দ করুন',
        detail: 'ফাইলটি সহায়তা দলের সাথে ভাগ করা হবে',
        content_placeholder: 'একটি বার্তা লিখুন *',
        content_required: '* বার্তা প্রয়োজন ',
        submit: 'প্রেরণ',
        cancel: 'বাতিল',
        sent: 'প্রেরিত'
      }
    },
    discussion: {
      join_discussion: 'আলোচনায় যোগ দিন'
    },
    notes: {
      title: 'আমার নোট',
      add_note: 'নতুন নোট যুক্ত করুন'
    }
  }
}
